import React from "react";
import TableEditable from "../TableEditable";

const FormUrl = ({ updateData, data }) => {
  return <TableEditable updateData={updateData} type="FORMURL" data={data} />;
};
export default FormUrl;
